import { installGoogleMaps } from './env';
import { fixMobileViewportUnits } from './fixMobileViewportUnits';
import { initializeDayjs } from './initializeDayjs';
import { initializeIntercom } from './intercom';
import { snapshotDebugInfo } from './snapshotDebugInfo';

export const onDocumentLoad = () => {
  initializeIntercom();
  installGoogleMaps();
  initializeDayjs();
  snapshotDebugInfo();
  fixMobileViewportUnits();
};
